import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { SymptomSection } from '../components/SymptomSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductDetailsSection } from '../components/ProductDetailsSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <main className="min-h-screen w-full overflow-x-hidden" data-id="element-220">
      <HeroSection data-id="element-221" />
      <SymptomSection data-id="element-222" />
      <SolutionSection data-id="element-223" />
      <ProductDetailsSection data-id="element-224" />
      <PricingSection data-id="element-225" />
      <Footer data-id="element-226" />
    </main>;
}